/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type SimCustomerInfoCreditClass =
  (typeof SimCustomerInfoCreditClass)[keyof typeof SimCustomerInfoCreditClass];

export const SimCustomerInfoCreditClass = {
  CreditClassA: "CreditClassA",
  CreditClassB: "CreditClassB",
  CreditClassC: "CreditClassC",
} as const;
